import { useErrorToastMessage } from '@hook/useErrorToastMessage';
import { QueryCache, QueryClient } from '@tanstack/react-query';
import axios from 'axios';
import i18next from 'i18next';

export const publicApi = axios.create({
    baseURL: '',
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000,
    withCredentials: window.isLoginFlag === 'true',
});

const { handleError } = useErrorToastMessage(i18next.t, 'remote');

export const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            onError: handleError,
        },
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 0,
            staleTime: 0,
        },
    },
    queryCache: new QueryCache({
        onError: handleError,
    }),
});
